import $api from "../Api";
import Endpoints from "../Endpoints";

const INTEGRATION_CODE_HEOXIFY = "heoxify";
const INTEGRATION_CODE_UYUMSOFT = "uyumsoft";

/**
 * Backend SoftResult sözleşmesi: HTTP 200 içinde isSuccess false gelebilir.
 * Bu yüzden ResponseChecker kullanılmaz; UI isSuccess alanına bakar.
 * @param {object} response
 * @returns {{ isSuccess: boolean, message: string, data: object|null, exceptionMessage?: string|null }}
 */
const normalizeSoftResult = (response) => {
  if (response?.isSuccess === true) {
    return {
      ...response,
      message: response.message || "OK",
      isSuccess: true,
      data: response.data ?? null,
      exceptionMessage: null,
    };
  }

  const code =
    response?.exceptionMessage ||
    (response?.message && response.message !== "FAIL"
      ? response.message
      : null);

  return {
    ...response,
    message: code || "FAIL",
    isSuccess: false,
    data: response?.data ?? null,
    exceptionMessage: code || null,
  };
};

/**
 * Heoxify (veya diğer provider) bağlantısını kurar / session yeniler.
 * Başarılı Heoxify yanıtında data.redirectUrl otomatik giriş adresi olabilir.
 * redirectUrl token içerir; log / localStorage / URL state'e yazılmamalıdır.
 * @param {{ integrationCode: string }} form
 */
export const Connect = async (form) => {
  const response = await $api.post(
    Endpoints.CompanyIntegrationConnection.Connect(),
    {
      integrationCode: form?.integrationCode,
    }
  );
  return normalizeSoftResult(response);
};

/**
 * Aktif bağlantı durumunu sorgular.
 * Bağlantı yoksa isSuccess: false döner (beklenen durum; hata modalı açılmaz).
 * Bağlantı varsa data.redirectUrl Heoxify otomatik giriş adresi olabilir.
 * @param {{ query: { integrationCode: string } }} option
 */
export const GetConnectStatus = async (option) => {
  const response = await $api.get(
    Endpoints.CompanyIntegrationConnection.GetConnectStatus(option)
  );
  return normalizeSoftResult(response);
};

/**
 * Bağlı entegrasyon kullanıcısı bilgisini getirir.
 * @param {{ query?: object }} [option]
 */
export const GetMe = async (option) => {
  const response = await $api.get(
    Endpoints.CompanyIntegrationConnection.GetMe(option)
  );
  return normalizeSoftResult(response);
};

export const IntegrationCodes = {
  HEOXIFY: INTEGRATION_CODE_HEOXIFY,
  UYUMSOFT: INTEGRATION_CODE_UYUMSOFT,
};

export default {
  Connect,
  GetConnectStatus,
  GetMe,
  IntegrationCodes,
};
